import MessageBox from '@/components/common/messagebox/MessageBox.vue'

export default {
  name: 'AdminSetup',
  data () {
    return {
      loading: false
    }
  },
  components: {
    MessageBox
  },
  methods: {
    getUserInviteList () {
      const self = this;
      this.loading = true;
      this.ApiRequest.request('setup/user-invite/list', this.ApiRequest.REQUEST_DOWNLOAD, [], function () {
        self.loading = false;
      });
    }
  }
}
